export enum PostPurchaseOptions {
  SendToWallet = 'sendToWallet',
  Stake = 'stake',
  Reinvest = 'reinvest',
  GenerateYield = 'generateYield',
}
